export default __webpack_public_path__ + "static/media/pci-dss-compliant-logo-vector.42cf73f8.svg";